module.exports = __webpack_public_path__ + "img/rileya.fc78103d.jpg";